





































































































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalProcedimentosVinculadosIncluir from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/modalProcedimentosVinculadosIncluir.vue'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    ModalProcedimentosVinculadosIncluir,
  },
})
export default class ModalProcedimentosVinculados extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadProcedimentoCompartilhado: boolean = false
  get loadingPRocedimentos() { return this.loadProcedimentoCompartilhado }
  set loadingPRocedimentos(value: boolean) { this.loadProcedimentoCompartilhado = value }

  get procedimentosHeader() {
    return [
      { text: 'Código TUSS', value: 'codigoTuss', sortable: false, align: 'center' },
      { text: 'Criado por', value: 'createdByNome', sortable: false, align: 'center' },
      { text: 'Criado em', value: 'createdOn', sortable: false, align: 'center' },
      { text: 'Ações', value: '', sortable: false, align: 'center' },
    ]
  }

  get procedimentos() { return this.getRegrasDeCalculoStore.procedimentosVinculados }
  get paginacaoProcedimentos() { return this.getRegrasDeCalculoStore.paginacaoProcedimentos }
  procedimentosDebounce = _.debounce(param => this.getRegrasDeCalculoStore.getProcedimentoCompartilhadoAll(param), 700)

  async updatePaginationProcedimentos(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingPRocedimentos = true
    this.procedimentosDebounce(pagination)
    this.loadingPRocedimentos = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarProcedimentoCompartilhado: string = ''
  get loadingDeletarProcedimentoCompartilhado() { return this.loadDeletarProcedimentoCompartilhado }
  set loadingDeletarProcedimentoCompartilhado(value: string) { this.loadDeletarProcedimentoCompartilhado = value }

  get showModalProcedimentos() { return this.getRegrasDeCalculoStore.modal.procedimentosVinculados }
  set showModalProcedimentos(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentosVinculados', value }) }

  get showModalProcedimentosIncluir() { return this.getRegrasDeCalculoStore.modal.procedimentosVinculadosIncluir }
  set showModalProcedimentosIncluir(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentosVinculadosIncluir', value }) }

  showModal() {
    this.getRegrasDeCalculoStore.setMode('CREATE')
    this.showModalProcedimentosIncluir = true
  }

  showModalDelete: boolean = false
  itemIdParaExcluir: string | null = null

  confirmarExclusao(id: string) {
    this.itemIdParaExcluir = id
    this.showModalDelete = true
  }

  async deleteItemConfirmado() {
    if (!this.itemIdParaExcluir) return

    this.loadingDeletarProcedimentoCompartilhado = this.itemIdParaExcluir
    this.showModalDelete = false

    this.getRegrasDeCalculoStore.setIdForDeleteProcedimentoVinculado(this.itemIdParaExcluir)
    const request = await this.getRegrasDeCalculoStore.removeProcedimentoVinculado()

    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Procedimento excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })
    }

    this.loadingDeletarProcedimentoCompartilhado = ''
    this.itemIdParaExcluir = null
  }
}
